import { AppsDocument } from 'src/graphql/actions/apps/apps.query';
import { apolloClient as client } from 'src/graphql/client/apollo-client';

export const refetchApps = () => {
  client.cache.evict({ fieldName: 'apps', broadcast: false });
  client.cache.gc();
  client.refetchQueries({
    include: [AppsDocument],
  });
};
